import { useContext, useEffect } from "react";
import { AuthContext } from "core/contexts/auth/auth";

const Logout = () => {
  const { signOut } = useContext(AuthContext);

  useEffect(() => {
    // Call the signOut function when the component mounts
    signOut();
  }, [signOut]);

  // This component doesn't render anything
  return null;
};

export default Logout;